<template>

<svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9997 25.1419C19.6665 25.1419 25.0711 19.7373 25.0711 13.0705C25.0711 6.40359 19.6665 0.999023 12.9997 0.999023C6.33279 0.999023 0.928223 6.40359 0.928223 13.0705C0.928223 19.7373 6.33279 25.1419 12.9997 25.1419Z" fill="#353B55" fill-opacity="0.08"/>
<path d="M8.6665 13.0703L11.9165 16.3203L18.4165 9.82031" stroke="#353B55" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
